import { setIdLeadInUrl } from "./setIdLeadInUrl.js";

export const checkLabelsUpdate = () => {
  if (typeof globalThis.statusDFI != "object") {
    globalThis.statusDFI = {};
  }

  var updateLabelsDelioCount = 0;
  var actualizadas = false;

  var updateLabelsDelio = setInterval(function () {
    updateLabelsDelioCount += 1;
    if (
      typeof digitalData != "undefined" &&
      typeof digitalData.cookies_accepted_analisis != "undefined" &&
      !actualizadas &&
      typeof DFI != "undefined" &&
      typeof DFI.labels != "undefined" &&
      typeof DFI.labels.EDeclaratives != "undefined" &&
      typeof DFI.labels.EDeclaratives.cookies_accepted_analisis == "undefined"
    ) {
      clearInterval(updateLabelsDelio);

      DFI.setDataLayer();
      globalThis.statusDFI.setDataLayer = true;
      DFI.setUtmsVars();
      globalThis.statusDFI.setUtmsVars = true;
      DFI.setTrackingVars();
      globalThis.statusDFI.setTrackingVars = true;
      DFI.setConversionsLabels();
      globalThis.statusDFI.setConversionsLabel = true;
      DFI.setDeclaratives();
      globalThis.statusDFI.setDeclaratives = true;
      DFI.refreshRingpool();

      setIdLeadInUrl(DFI.getLeadId(), [
        "https://iframe.electric-save.com/endesa/comparadorPortugal",
        "https://www.endesaclientes.pt/uPortal2/MyEndesa/formulario/form_index.html",
      ]);

      actualizadas = true;
    }

    if (
      updateLabelsDelioCount > 50 &&
      !actualizadas &&
      typeof DFI != "undefined"
    ) {
      clearInterval(updateLabelsDelio);

      setIdLeadInUrl(DFI.getLeadId(), [
        "https://iframe.electric-save.com/endesa/comparadorPortugal",
        "https://www.endesaclientes.pt/uPortal2/MyEndesa/formulario/form_index.html",
      ]);

      actualizadas = true;
    }
  }, 500);
};
